import { authHttp } from '../http'
import * as routes from '../../routes/settings.routes'
import { errorHandler } from '../../../util/error.service'

export async function getCompanies() {
  try {
    const response = await authHttp().get(routes.urlCompanies)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getCompaniesUser() {
  try {
    const response = await authHttp().get(routes.urlCompaniesUser)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveCompany({
  id,
  name,
  cnpj,
  actived,
  allow_duplicated_ean,
  oc_nf_dev_total,
  qte_caixas_por_pallet,
  enabled_desdobramento_produto,
  sigla,
  company_code,
  razao_social,
  phone,
  address,
  number,
  district,
  city_id,
  cep,
  inscricao_estadual,
  frete_min,
  generic_product_code,
  enviar_email_cte,
  email_destinatario_cte,
  business_unit,
  ciot_natureza_carga,
  ciot_tipo_carga,
  ciot_prazo_pagamento_dias,
}) {
  try {
    const response = id
      ? await authHttp().put(routes.urlCompany, {
          id,
          name,
          cnpj,
          actived,
          allow_duplicated_ean,
          oc_nf_dev_total,
          qte_caixas_por_pallet,
          enabled_desdobramento_produto,
          sigla,
          company_code,
          razao_social,
          phone,
          address,
          number,
          district,
          city_id,
          cep,
          inscricao_estadual,
          frete_min,
          generic_product_code,
          enviar_email_cte,
          email_destinatario_cte,
          business_unit,
          ciot_natureza_carga,
          ciot_tipo_carga,
          ciot_prazo_pagamento_dias,
        })
      : await authHttp().post(routes.urlCompany, {
          name,
          cnpj,
          actived,
          allow_duplicated_ean,
          oc_nf_dev_total,
          qte_caixas_por_pallet,
          enabled_desdobramento_produto,
          sigla,
          company_code,
          razao_social,
          phone,
          address,
          number,
          district,
          city_id,
          cep,
          inscricao_estadual,
          frete_min,
          generic_product_code,
          enviar_email_cte,
          email_destinatario_cte,
          business_unit,
          ciot_natureza_carga,
          ciot_tipo_carga,
          ciot_prazo_pagamento_dias,
        })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
